import { FlexBox, Icon } from '@dixa/lib-shared-habla';
import {
  FilterInfo,
  LanguageEvaluationResult,
  SurveyInfo,
} from 'lib-shared-types-api';

import { FilterItemWithDetails, FilterLink, SurveyLink } from '../shared';

type SelectedFilterItemProps = {
  filter: FilterInfo;
  survey: SurveyInfo;
  contactPointLabel: string;
  contactPointValue: string | null;
  languageEvaluations: readonly LanguageEvaluationResult[];
};

/**
 * Displays the selected filter that was actually used to send the survey. Shows
 * checkmark, action-oriented text, and expandable details.
 */
export const SelectedFilterItem = ({
  filter,
  survey,
  contactPointLabel,
  contactPointValue,
  languageEvaluations,
}: SelectedFilterItemProps): JSX.Element => {
  return (
    <FilterItemWithDetails
      contactPointValue={contactPointValue}
      languageEvaluations={languageEvaluations}
    >
      <FlexBox gap="200" alignItems="center">
        Filter: <FilterLink filter={filter} /> triggered and the delivery of{' '}
        <SurveyLink survey={survey} /> via {contactPointLabel} was matched and
        SELECTED
        <Icon
          name="check-circle-filled"
          size={16}
          color="var(--dixa-color-green-400)"
        />
      </FlexBox>
    </FilterItemWithDetails>
  );
};
